import { ref } from 'vue'
import { defineStore } from 'pinia'
import env from '@shared/env.js'
import useSharedStore from '@shared/stores/useSharedStore.js'
import { INCENTIVE_VARIANTS } from '@shared/data/models/corporate.js'

const usePersistedConfigStore = defineStore(
  'persistedConfig',
  () => {
    const performanceTrackingEnabled = ref(/** @type { boolean } */ env.isUs)
    const targetingEnabled = ref(/** @type { boolean|null } */ null)
    const cookieDialogShown = ref(/** @type { boolean } */ false)
    const incentive = ref(/** @type { string|null } */ null)

    /**
     * Assign incentive variant based on URL query or corporate settings
     * @param corporate {Corporate}
     */
    const assignIncentiveVariant = (corporate) => {
      const sharedStore = useSharedStore()

      // Priority: URL query > Corporate incentive > None
      incentive.value =
        INCENTIVE_VARIANTS[sharedStore.initialQuery.incentive] ||
        corporate.activeIncentive?.variant ||
        null

      // Update utm_campaign to include incentive info for tracking
      const currentCampaign = sharedStore.utmData.utm_campaign || ''
      const campaignParts = currentCampaign
        .split('_')
        .filter((part) => part && !part.startsWith('landing-incentive-'))

      if (incentive.value) {
        campaignParts.push(`landing-incentive-${incentive.value}`)
      }

      const newCampaign = campaignParts.join('_')
      if (newCampaign !== currentCampaign) {
        sharedStore.storeInitialQuery({ utm_campaign: newCampaign })
      }
    }

    return {
      performanceTrackingEnabled,
      targetingEnabled,
      cookieDialogShown,
      incentive,
      assignIncentiveVariant,
    }
  },
  {
    persist: {
      storage: localStorage,
    },
  },
)

export default usePersistedConfigStore
